// extracted by mini-css-extract-plugin
export default {"coins":"Lg4I42SLeELuwCgXQPQ2wA==","buttonsInRow":"Hpe3-V-Rd56WMZeet3GetA==","button":"Flg-K6mRsvQR4xV-9Uivsw==","link":"_2oI43b0-jLBy3X+KZlUEtQ=="};